import { CartItem } from './CartItem';

export class CartPopup {
    QuoteNumber: number;
    QuoteDate: Date;
    CartCount: number;
    CartItems: CartItem[];
    CartTotalPrice: number;
}
